import { Link } from 'react-router-dom'

/** Public privacy summary — expand with counsel before GA launch. */
export function PrivacyPage() {
  return (
    <div className="min-h-screen" style={{ background: '#F5F2EA' }}>
      <div className="max-w-xl mx-auto px-4 py-10">
        <Link
          to="/login"
          className="text-xs mb-8 inline-block transition-colors"
          style={{ color: '#9aafb3' }}
        >
          ← Back to sign in
        </Link>

        <header className="mb-10">
          <div className="text-3xl mb-2">🕊</div>
          <h1
            className="text-2xl font-bold tracking-tight"
            style={{ color: '#1a3a40', fontFamily: 'Georgia, serif' }}
          >
            Privacy
          </h1>
          <p className="text-sm mt-2" style={{ color: '#3d6068' }}>
            What we collect, why, and your choices. For questions:{' '}
            <a href="mailto:privacy@getduva.com" style={{ color: '#2A7A8A' }}>
              privacy@getduva.com
            </a>
            .
          </p>
        </header>

        <div
          className="rounded-2xl p-8 space-y-6"
          style={{
            background: '#FDFCF8',
            border: '1px solid #e0d9cc',
            boxShadow: '0 2px 16px rgba(42,122,138,0.07)',
          }}
        >
          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Data we process
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              To deliver nudges and analytics, we process workspace identifiers, user profile fields provided by
              Slack/Teams/SSO (such as name and email), delivery and engagement events, and content required to run
              your organization&apos;s configured programs.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Purposes &amp; legal bases
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              Processing is done to perform our contract with you (provide the service), comply with law where
              applicable, and pursue legitimate interests such as security and product improvement, balanced against
              your rights. Enterprise customers may rely on a data processing agreement — request one from your
              account contact.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Retention &amp; deletion
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              We retain data as needed to operate the product and meet legal obligations. End users may request
              deletion of personal data via in-app Settings (GDPR erasure flow). We will respond within a reasonable
              timeframe.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Subprocessors
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              We use infrastructure providers (e.g. Cloudflare for compute, database, and hosting). A current list is
              available on request for Enterprise customers.
            </p>
          </section>

          <p className="text-xs pt-4 border-t" style={{ color: '#9aafb3', borderColor: '#e0d9cc' }}>
            This is a working summary, not a substitute for a jurisdiction-specific privacy policy. See also{' '}
            <Link to="/terms" className="underline underline-offset-2" style={{ color: '#2A7A8A' }}>
              Terms
            </Link>
            {' '}and{' '}
            <Link to="/security" className="underline underline-offset-2" style={{ color: '#2A7A8A' }}>
              Security
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  )
}
